import React, { useEffect, useState } from 'react';
import { CheckCircle, AlertCircle, CreditCard } from 'lucide-react';
interface ProcessingAnimationProps {
  onComplete: () => void;
  status: 'processing' | 'success' | 'error';
}
export function ProcessingAnimation({
  onComplete,
  status
}: ProcessingAnimationProps) {
  const [message, setMessage] = useState('Connecting to your bank...');
  useEffect(() => {
    if (status === 'processing') {
      const timer1 = setTimeout(() => setMessage('Verifying OTP...'), 3000);
      const timer2 = setTimeout(() => setMessage('Processing payment...'), 3000);
      const timer3 = setTimeout(() => setMessage('Finalizing transaction...'), 4500);
      return () => {
        clearTimeout(timer1);
        clearTimeout(timer2);
        clearTimeout(timer3);
      };
    } else if (status === 'success') {
      setMessage('Payment Successful!');
      const timer = setTimeout(() => onComplete(), 5000);
      return () => clearTimeout(timer);
    } else if (status === 'error') {
      setMessage('Payment Failed');
    }
  }, [status, onComplete]);
  return <div className="flex flex-col items-center justify-center py-12 text-center" data-id="element-594" data-mp="3lhris12dovzq">
      {status === 'processing' && <div className="relative mb-8" data-id="element-595" data-mp="3pj3coisac3dq">
          <div className="w-24 h-24 border-4 border-blue-100 rounded-full" data-id="element-596" data-mp="3pk4m6itnkhtc"></div>
          <div className="w-24 h-24 border-4 border-blue-600 rounded-full border-t-transparent animate-spin absolute top-0 left-0" data-id="element-597" data-mp="3uhn06nmj1n87"></div>
          <div className="absolute inset-0 flex items-center justify-center" data-id="element-598" data-mp="2xqcdq0j7w0ks">
            <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center animate-pulse" data-id="element-599" data-mp="31uk21wlrjeih">
              <CreditCard className="w-8 h-8 text-blue-600" data-id="element-600" data-mp="36rso48a182p0" />
            </div>
          </div>
        </div>}

      {status === 'success' && <div className="mb-8 transform scale-100 transition-transform duration-500 ease-out" data-id="element-601" data-mp="2e4prxmstw41x">
          <CheckCircle className="w-24 h-24 text-green-500" data-id="element-602" data-mp="2j3j67hfxvz35" />
        </div>}

      {status === 'error' && <div className="mb-8" data-id="element-603" data-mp="3meghhglr60yw">
          <AlertCircle className="w-24 h-24 text-red-500" data-id="element-604" data-mp="3mdnbwiyj5hic" />
        </div>}

      <h2 className={`text-2xl font-bold mb-2 ${status === 'success' ? 'text-green-600' : status === 'error' ? 'text-red-600' : 'text-gray-900'}`} data-id="element-605" data-mp="3hflppp5t522n">
        {status === 'success' ? 'Transaction Approved' : status === 'error' ? 'Transaction Declined' : 'Processing Payment'}
      </h2>

      <p className="text-gray-600 animate-pulse" data-id="element-606" data-mp="3r7j6dbfl4m8r">{message}</p>

      {status === 'processing' && <p className="text-sm text-gray-500 mt-8 max-w-xs" data-id="element-607" data-mp="33hfchvs780uy">
          Please do not close this window or press the back button.
        </p>}
    </div>;
}